import facetName from './facetName';

const facetObserver = () => {

	jQuery(document).on('facetwp-loaded', function () {

		jQuery('[data-facet-observer],[data-facet-observer-inverted],[data-facet-observer-all]').removeClass('facet__observe--true');
		jQuery('[data-facet-observer-text]').text('');

		let facetUsed = false;

		Object.keys(FWP.facets).forEach(function (key) {

			if (FWP.facets[key].length > 0) {

				facetUsed = true;

				// # observer trigger

				jQuery('[data-facet-observer*="'+key+'"]').addClass('facet__observe--true');

				// # mobile facet labels

				let text = [];
				Array.from(FWP.facets[key]).forEach(facet => {
				  let name = facetName(key,facet,FWP.facet_type[key]);
          if(typeof name !== "undefined") {
            if(FWP.facet_type[key] == 'proximity') {
              text = []
              text.push(name);
            } else {
              text.push(name);
            }
          }
				});

				jQuery('[data-facet-observer-text*="'+key+'"]').text(Object.keys(text).map(function(k){return text[k]}).join(","));

			} else {

				jQuery('[data-facet-observer-inverted*="'+key+'"]').addClass('facet__observe--true');

			}

		});

		// # mobile sort label

		if(FWP.extras.sort) {

			if(FWP.extras.sort != 'default') {
				jQuery('[data-facet-observer="sort"]').addClass('facet__observe--true');
			} else {
				jQuery('[data-facet-observer-inverted="sort"]').addClass('facet__observe--true');
			}

			let name = facetName(null,FWP.extras.sort,'sort');
			if(typeof name !== "undefined") {
				jQuery('[data-facet-observer-text="sort"]').text(name);
			}

		}

		// # trigger class if facets used

		if(facetUsed) {
			jQuery('[data-facet-observer-all]').addClass('facet__observe--true');
		}

	});


};

export default facetObserver;
